// removed by extract-text-webpack-plugin
module.exports = {"support":"OnlineSupport-m__support___3cJGh","supportTop":"OnlineSupport-m__supportTop___T_NJd","supportLinks":"OnlineSupport-m__supportLinks___wkipS","supportLink":"OnlineSupport-m__supportLink___3Vzig","supportLinkIcon":"OnlineSupport-m__supportLinkIcon___nzmzK","supportLinkText":"OnlineSupport-m__supportLinkText___1tXO7"};


//////////////////
// WEBPACK FOOTER
// ./components/onlineSupport/OnlineSupport.m.sass
// module id = FbCo
// module chunks = 0